import React from 'react';

export default function CheckIcon() {
    return <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 5.84848L6.1 11L16 1" stroke="#2AC769" strokeWidth="2"/> </svg> 
}